module.exports = __webpack_public_path__ + "static/media/S (121).88208803.jpg";